import { useEffect, useState } from 'react';
import { Consts, NotificationsEventType } from '../../lib/em/EmitTypes';
import { useEventEmitter } from '../../lib/em/Hooks';
import { P2GFade, P2GAlert } from '@parcel2go/core-ui';

export interface message {
  key: string;
  message: string | React.ReactNode;
  variant: 'info' | 'warning' | 'error' | 'success';
}

interface notificationProps extends message {
  onClose: (key: string) => void;
}

const Notification = (props: notificationProps) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer1 = setTimeout(close, 5000);
    return () => {
      clearTimeout(timer1);
    };
  }, []);

  const close = () => {
    setShow(false);
    setTimeout(() => {
      props.onClose(props.key);
    }, 450);
  };

  return (
    <P2GFade in={show}>
      <P2GAlert onClick={close} color={props.variant}>
        {props.message}
      </P2GAlert>
    </P2GFade>
  );
};

export default function Notifications() {
  const [messages, setMessages] = useState<message[]>([]);
  const { useListener } = useEventEmitter<NotificationsEventType>();
  useListener(Consts.Notifications, (m) => setMessages([...messages, m]), [messages]);

  const remove = (d: string) => {
    setMessages([...messages].filter((x) => x.key !== d));
  };

  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <div style={{ position: 'fixed', top: 10, right: 10, width: '250px', zIndex: 9999 }}>
      {messages.map((m) => (
        <Notification key={m.key} message={m.message} variant={m.variant} onClose={() => remove(m.key)} />
      ))}
    </div>
  );
}
